// In-memory hand-off of original uploaded files from Design Studio to Custom Order (too big for sessionStorage)
export const designAssets = { originals: [] };
